import React, {useState, useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import Header from "../../../components/layout/Header";
import Wrapper from "../../../components/layout/Wrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faCode, faCoins, faFaceLaugh, faFire, faGear, faHandPaper,
    faHome,
    faMoneyBill,
    faPencil, faPerson, faTable,
    faTablet,
    faTrophy,
    faUniversity
} from '@fortawesome/free-solid-svg-icons';
import Footer from "../../../components/layout/Footer";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import MasterSearch from "../../../components/layout/MasterSearch";
import AccountMenu from "../AccountMenu";
import AccountSidebar from "../AccountSidebar";
import {useAuth} from "../../../context/AuthProvider";


const CheatSheetMain = () => {

    const {course_id} = useParams();

    const breadC = [
        {title: 'حساب‌کاربری', link: '#'},
        {title: 'دوره‌های من', link: '/fa/account/course'},
        {title: 'HTML', link: `/fa/account/course/${course_id}`},
        {title: 'تقلب‌نامه', link: `/fa/account/course/${course_id}/cheatsheet`},
    ];

    const {user} = useAuth();

    return (
        <>
            <div className='min-h-screen flex flex-col'>
                <Header/>
                <main className='flex-1 my-8'>
                    <Wrapper>
                        <div>
                            <div className='w-full flex flex-1 gap-x-10'>
                                <AccountSidebar name={user.name} phone_number={user.phone_number} credit={user.credit}
                                                streak={user.streak} xp={user.xp}
                                                character={user.character}/>

                                <div className='w-4/5'>
                                    <Breadcrumb items={breadC} wrapper={false}/>
                                    <h1 className='mt-10 text-3xl'>تقلب‌نامه HTML</h1>
                                    <MasterSearch className='mt-8' />
                                    <table className='mt-10 w-full border-2 text-lg font-bold text-gray-400 rounded-full border-gray-200'>
                                        <tr className='flex items-center w-full flex-1 justify-between border-b-2'>
                                            <td className='flex p-3 justify-center border-l-2'>نام</td>
                                            <td className='flex p-3 justify-center border-l-2'>نوع</td>
                                            <td className='flex p-3 justify-center'>مثال</td>
                                        </tr>
                                        <tr className='flex items-center w-full flex-1 justify-between'>
                                            <td className='flex p-3 justify-center border-l-2'>نام</td>
                                            <td className='flex p-3 justify-center border-l-2'>نوع</td>
                                            <td className='flex p-3 justify-center'>مثال</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </main>
                <Footer/>
            </div>
        </>
    );
};

export default CheatSheetMain;
